import type { CallbackInterface } from 'recoil'

import { pageState } from 'State/page'

import type { PageStateType } from 'Types/state'

import {
  getIntegrationsAction,
  getOptionsAction,
} from 'Pages/ImportLanding/services'

import {
  errorState,
  importOptionsState,
  integrationsState,
} from 'Pages/ImportLanding/state'

export const initPageCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set(pageState, (prev) => ({ ...prev, state: 'initial', loading: true }))

    set(importOptionsState, getOptionsAction())

    try {
      const items = await getIntegrationsAction()
      set(integrationsState, items)
    } catch (error) {
      set(errorState, true)
    }

    set<PageStateType>(pageState, (prev) => ({
      ...prev,
      loading: false,
      status: 'ready',
    }))
  }

export const resetPageCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(pageState)

    reset(integrationsState)
    reset(importOptionsState)
  }
